// extracted by mini-css-extract-plugin
module.exports = {"resultsContainer":"SearchResults_resultsContainer__mmiAH","resultsHeader":"SearchResults_resultsHeader__Q20wY"};